const SetTheme = () => {
  const storageKey = 'theme-preference'

  const changeTheme = document.querySelectorAll('.block.theme .option')

  changeTheme.forEach(function (btn) {
    btn.addEventListener('click', function () {
      let selectedTheme = btn.dataset.theme

      theme.value = selectedTheme
      setPreference()
    })
  })

  const getColorPreference = () => {
    if (localStorage.getItem(storageKey))
      return localStorage.getItem(storageKey)
    else return 'default'
  }

  const setPreference = () => {
    localStorage.setItem(storageKey, theme.value)
    reflectPreference()
  }

  const reflectPreference = () => {
    document.firstElementChild.setAttribute('data-theme', theme.value)
  }

  const theme = {
    value: getColorPreference(),
  }

  // set early so no page flashes / CSS is made aware
  reflectPreference()
}

export default SetTheme
